//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Link } from 'react-router-dom'
//@end

//@import components
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
import {routingService} from 'app_services/routingService'
// @end

// @INFO Import Styles
import './../breadcrumbCommon.scss'

// @ADD Component types
interface IBreadcrumbLinksCommonLayoutProps {
  texts: string[]
  links: any[]
}

const BreadcrumbLinksCommonLayout: React.FC<IBreadcrumbLinksCommonLayoutProps> = (props) => {

  const { t } = useTranslation()

  function goBack(index: number) {
    // props.links[index].goBack()
  }

  return(
    <div className='breadcrumb-component'>
      <nav aria-label='breadcrumb'>
        <ol className='breadcrumb'>
          <li className='breadcrumb-item'>
            <Link to={routingService.getSecurePath()}>
              <span>{t('components.breadcrumb.start')} </span>
            </Link>
          </li>

          {props.links.map((link: any, i: number) => (
            <li key={link} className='breadcrumb-item'>
              {typeof link === 'string' && link !== '#' ? (
                <Link to={routingService.getSecurePath(link)}>
                  <span className='text-truncate'>{props?.texts[i] || link}</span>
                </Link>
              ) : (
                <Link to='#'>
                  <span
                    className='text-truncate'
                    onClick={() => {
                      goBack(i)
                    }}
                  >
                    {props.texts[i] || link}
                  </span>
                </Link>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </div>
  )
}

export default BreadcrumbLinksCommonLayout
